(() => {
  const CONFIG = {
    linkSelector: '.b7-product-color__link, .b7-product-size__link, .b7-product-material__link',
    productInfoSelector: '.product-information',
    sectionWrapperSelector: '[id^="shopify-section-"]',
    swappingClass: 'b7-pdp-swapping',
    fadeInClass: 'b7-pdp-fade-in',
    familyMediaJsonId: 'b7-family-media', // ✅ [추가] 변종 이미지 프리로드용 JSON id
  };

  // ✅ [변경 1] prefetchingSet(Set) → inflight(Map)
  // 진행 중인 요청의 Promise 자체를 들고 있어야 클릭이 거기에 편승할 수 있음
  const pageCache = new Map();   // abs -> html (완료된 HTML)
  const inflight = new Map();    // abs -> Promise<html> (진행 중인 요청)
  let currentController = null;

  let b7StoqRunId = 0;
  let b7StoqCheckTimer = null;

  // ─────────────────────────────────────────
  // 유틸
  // ─────────────────────────────────────────

  const absUrl = (url) => new URL(url, location.origin).toString();

  const getProductInfoRoot = (scope = document) =>
    scope.querySelector(CONFIG.productInfoSelector) || document.querySelector(CONFIG.productInfoSelector);

  const getProductForm = (scope = document) => {
    const root = getProductInfoRoot(scope);
    if (!root) return null;
    return (
      root.querySelector('form[action*="/cart/add"]') ||
      root.querySelector('.product-form form') ||
      root.querySelector('form')
    );
  };

  const ensureVariantInput = (scope = document) => {
    const form = getProductForm(scope);
    if (!form) return null;
    let input = form.querySelector('[name="id"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'id';
      form.appendChild(input);
    }
    return input;
  };

  const getVariantId = (scope = document) => {
    const input = ensureVariantInput(scope);
    return input?.value || input?.getAttribute('value') || null;
  };

  const setVariantId = (variantId, scope = document) => {
    const input = ensureVariantInput(scope);
    if (!input || !variantId) return false;
    input.value = String(variantId);
    input.setAttribute('value', String(variantId));
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  };

  const getStoqAnchor = (scope = document) => {
    const root = getProductInfoRoot(scope) || scope;
    return root.querySelector('#b7-stoq-anchor') || document.querySelector('#b7-stoq-anchor');
  };

  // ─────────────────────────────────────────
  // RestockRocket
  // ─────────────────────────────────────────

  const runStoqOnce = (scope = document, runId) => {
    const variantId = getVariantId(scope);
    const anchor = getStoqAnchor(scope);
    const api = window._RestockRocket?.renderButtonForVariant;

    if (!variantId || !anchor || typeof api !== 'function') {
      console.warn('[b7][stoq] 실행 조건 불충족');
      return;
    }

    setVariantId(variantId, scope);

    try {
      api(String(variantId));
    } catch (e) {
      console.error('[b7][stoq] render 예외', e);
      return;
    }

    let checks = 0;
    const check = () => {
      if (runId !== b7StoqRunId) return;
      return;
      checks += 1;
      const btn =
        document.querySelector('.restock-rocket-button-container') ||
        document.querySelector('.restock-rocket-button-product') ||
        document.querySelector('[class*="restock-rocket"]');
      if (btn) {
        if (anchor && !anchor.contains(btn)) anchor.appendChild(btn);
        return;
      }
      if (checks >= 10) return;
      b7StoqCheckTimer = setTimeout(check, 250);
    };

    if (b7StoqCheckTimer) clearTimeout(b7StoqCheckTimer);
    b7StoqCheckTimer = setTimeout(check, 250);
  };

  window.b7ReinitRestockRocket = () => {
    b7StoqRunId += 1;
    const runId = b7StoqRunId;
    if (b7StoqCheckTimer) {
      clearTimeout(b7StoqCheckTimer);
      b7StoqCheckTimer = null;
    }
    setTimeout(() => {
      if (runId !== b7StoqRunId) return;
      runStoqOnce(document, runId);
    }, 500);
  };

  // ─────────────────────────────────────────
  // Fetch / Prefetch
  // ─────────────────────────────────────────

  // ✅ [변경 2] fetchHtml: 진행 중인 요청(inflight)에 편승하도록 변경
  // → 프리페치 도중 클릭해도 같은 URL을 또 요청하지 않음
  const fetchHtml = (url, signal) => {
    const abs = absUrl(url);
    if (pageCache.has(abs)) return Promise.resolve(pageCache.get(abs));
    if (inflight.has(abs)) return inflight.get(abs);

    const p = fetch(abs, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal,
    })
      .then(res => res.text())
      .then(html => {
        pageCache.set(abs, html);
        inflight.delete(abs);
        return html;
      })
      .catch(err => {
        inflight.delete(abs);
        throw err;
      });

    inflight.set(abs, p);
    return p;
  };

  // ✅ [추가] 지금 보고 있는 슬라이드 인덱스 (없거나 0이면 0)
  const getSavedIdx = () => {
    try {
      const n = parseInt(sessionStorage.getItem('b7_pdp_swiper_idx'), 10);
      return Number.isFinite(n) && n > 0 ? n : 0;
    } catch (e) { return 0; }
  };

  // ✅ [변경] 프리페치한 HTML에서 "첫 이미지 + 지금 보고 있는 슬라이드" 이미지를 데움
  // → 3번째 슬라이드를 보던 중 변종을 바꿔도 그 위치 이미지가 미리 준비됨
  const warmImageFromHtml = (html) => {
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const imgs = doc.querySelectorAll('.b7-media-swiper .swiper-slide img');
      if (!imgs.length) return html;

      const warm = (n) => {
        const s = imgs[n]?.getAttribute('src');
        if (s) { const i = new Image(); i.src = s; }
      };

      warm(0); // 첫 장은 항상

      let idx = getSavedIdx();
      if (idx > imgs.length - 1) idx = imgs.length - 1; // 이미지 수 초과 시 마지막으로
      if (idx > 0) warm(idx); // 지금 보고 있는 위치
    } catch (e) {}
    return html;
  };

  // ✅ [변경 3] prefetchUrl: HTML 캐시 + 그 안의 첫 이미지까지 같이 데움
  const prefetchUrl = (url) => {
    const abs = absUrl(url);
    if (pageCache.has(abs) || inflight.has(abs)) return;
    fetchHtml(abs).then(warmImageFromHtml).catch(() => {});
  };

  // ✅ [추가] 변종 이미지 미리 데우기 (가장 체감 큰 부분)
  // #b7-family-media JSON에 들어있는 각 색상의 첫 이미지를 미리 다운로드
  const warmVariantImages = () => {
    const el = document.getElementById(CONFIG.familyMediaJsonId);
    if (!el) return;
    let data;
    try { data = JSON.parse(el.textContent); } catch (e) { return; }
    const products = data?.products || {};
    Object.values(products).forEach(p => {
      const urls = (p.media || []).filter(Boolean);
      // 최소 첫 장은 무조건 데움 (더 공격적으로 하려면 slice(0,3))
      if (urls[0]) { const img = new Image(); img.src = urls[0]; }
    });
  };

  // ✅ [변경 4] HTML 프리페치: idle 직렬 → 즉시 병렬(동시 4개)로 캐시 워밍
  const prefetchAllVariantLinks = () => {
    const links = Array.from(document.querySelectorAll(CONFIG.linkSelector))
      .map(a => a.getAttribute('href'))
      .filter(href => href && href !== location.pathname);

    const unique = [...new Set(links)];
    if (!unique.length) return;

    let i = 0;
    const CONCURRENCY = 4;
    const worker = () => {
      if (i >= unique.length) return;
      const abs = absUrl(unique[i++]);
      prefetchUrl(abs);
      (inflight.get(abs) || Promise.resolve()).finally(worker); // 동시 4개 유지
    };
    for (let k = 0; k < CONCURRENCY; k++) worker();
  };

  // ─────────────────────────────────────────
  // Script 재실행
  // ─────────────────────────────────────────

  const rerunScripts = (container, key) => {
    container.querySelectorAll(`script[data-b7-rerun="${key}"]`).forEach(old => {
      const s = document.createElement('script');
      s.text = old.textContent;
      document.body.appendChild(s);
      s.remove();
    });
  };

  // ─────────────────────────────────────────
  // Judge.me 배지 스냅샷
  // ─────────────────────────────────────────

  const snapshotBadgeHtml = () => {
    const snapshots = [];
    document.querySelectorAll('.jdgm-widget.jdgm-preview-badge').forEach((widget, i) => {
      const prevBadge = widget.querySelector('.jdgm-prev-badge');
      if (prevBadge && prevBadge.innerHTML.trim()) {
        snapshots.push({
          index: i,
          widgetHtml: widget.innerHTML,
          widgetClasses: widget.className,
        });
      }
    });
    return snapshots;
  };

  const injectBadgeSnapshot = (snapshots) => {
    if (!snapshots || !snapshots.length) return;
    const newWidgets = document.querySelectorAll('.jdgm-widget.jdgm-preview-badge');
    snapshots.forEach(({ index, widgetHtml, widgetClasses }) => {
      const target = newWidgets[index];
      if (!target) return;
      target.className = widgetClasses;
      target.innerHTML = widgetHtml;
    });
  };

  // ─────────────────────────────────────────
  // 첫 번째 슬라이드 이미지 preload
  // ─────────────────────────────────────────
  const preloadFirstImage = (doc) => {
    const imgs = doc.querySelectorAll('.b7-media-swiper .swiper-slide img');
    if (!imgs.length) return Promise.resolve();

    // ✅ 지금 보고 있는 슬라이드 위치의 이미지를 데움 (없으면 첫 장)
    let idx = getSavedIdx();
    if (idx > imgs.length - 1) idx = imgs.length - 1;
    const targetImg = imgs[idx] || imgs[0];

    const src = targetImg.getAttribute('src');
    if (!src) return Promise.resolve();

    const img = new Image();
    img.src = src;

    // ✅ onload만이 아니라 decode까지 기다림 → 화면에 그려질 때 끊김 없음
    const done = (typeof img.decode === 'function')
      ? img.decode().catch(() => {})
      : new Promise((resolve) => { img.onload = resolve; img.onerror = resolve; });

    // 300ms 안에 안 끝나면 그냥 진행 (너무 오래 기다리지 않음)
    return Promise.race([done, new Promise((resolve) => setTimeout(resolve, 300))]);
  };

  // ─────────────────────────────────────────
  // AJAX 섹션 교체
  // ─────────────────────────────────────────

  const swapSections = async (url, push = true) => {
    const currentSection = document
      .querySelector(CONFIG.productInfoSelector)
      ?.closest(CONFIG.sectionWrapperSelector);
    if (!currentSection) return;

    if (currentController) currentController.abort();
    currentController = new AbortController();

    const badgeSnapshots = snapshotBadgeHtml();

    document.documentElement.classList.add(CONFIG.swappingClass);

    try {
      const html = await fetchHtml(url, currentController.signal);
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const nextSection = doc
        .querySelector(CONFIG.productInfoSelector)
        ?.closest(CONFIG.sectionWrapperSelector);

      if (!nextSection) throw new Error('section 없음');

      const newProductId = doc
        .querySelector('[data-product-id]')
        ?.getAttribute('data-product-id');

      await preloadFirstImage(doc);

      document.documentElement.classList.remove(CONFIG.swappingClass);

      nextSection.classList.add(CONFIG.fadeInClass);

      currentSection.replaceWith(nextSection);

      if (push) history.pushState({}, '', url);
      document.title = doc.title;

      // AJAX 변종 전환임을 표시 → 스와이퍼가 저장된 슬라이드 인덱스를 유지
      window.__b7AjaxSwap = true;
      rerunScripts(nextSection, 'swiper');
      rerunScripts(nextSection, 'pdp');
      window.__b7AjaxSwap = false;

      injectBadgeSnapshot(badgeSnapshots);

      setTimeout(() => {
        nextSection.classList.remove(CONFIG.fadeInClass);
      }, 200);

      // 교체 후 새 DOM 변종 링크/이미지 다시 워밍
      warmVariantImages();
      prefetchAllVariantLinks();

      setTimeout(() => {
        window.b7ReinitRestockRocket();
      }, 700);

    } catch (e) {
      if (e.name !== 'AbortError') console.error('[b7] ajax 실패', e);
      document.documentElement.classList.remove(CONFIG.swappingClass);
    }
  };

  // ─────────────────────────────────────────
  // 이벤트 바인딩
  // ─────────────────────────────────────────

  document.addEventListener('click', (e) => {
    const a = e.target.closest(CONFIG.linkSelector);
    if (!a) return;
    const href = a.getAttribute('href');
    if (!href) return;
    e.preventDefault();
    swapSections(href, true);
  });

  // ✅ [변경 5] 첫 상호작용 보험: pointerdown에서 프리페치 (click보다 먼저 발생)
  document.addEventListener('pointerdown', (e) => {
    const a = e.target.closest(CONFIG.linkSelector);
    if (!a) return;
    const href = a.getAttribute('href');
    if (href) prefetchUrl(href);
  });

  // hover prefetch
  document.addEventListener('mouseover', (e) => {
    const a = e.target.closest(CONFIG.linkSelector);
    if (!a) return;
    const href = a.getAttribute('href');
    if (href) prefetchUrl(href);
  });

  // 터치 prefetch
  document.addEventListener('touchstart', (e) => {
    const a = e.target.closest(CONFIG.linkSelector);
    if (!a) return;
    const href = a.getAttribute('href');
    if (href) prefetchUrl(href);
  }, { passive: true });

  window.addEventListener('popstate', () => {
    swapSections(location.href, false);
  });

  // ─────────────────────────────────────────
  // ✅ [변경 4-2] 페이지 로드 직후 즉시 워밍 (idle 기다리지 않음)
  // ─────────────────────────────────────────
  const warmAll = () => {
    warmVariantImages();
    prefetchAllVariantLinks();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', warmAll);
  } else {
    warmAll();
  }

})();




// 수량 선택기 값이 1일 때 마이너스 버튼에 disable 추가
  function updateMinusButton(selector) {
    const input = selector.querySelector('.quantity-input');
    const minusButton = selector.querySelector('.quantity-minus');

    if (!input || !minusButton) return;

    const quantity = parseInt(input.value, 10) || 1;
    minusButton.disabled = quantity <= 1;
  }

  document.querySelectorAll('quantity-selector-component').forEach((selector) => {
    const input = selector.querySelector('.quantity-input');
    const buttons = selector.querySelectorAll('.quantity-button');

    updateMinusButton(selector);

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        setTimeout(() => updateMinusButton(selector), 0);
      });
    });

    input?.addEventListener('input', () => {
      updateMinusButton(selector);
    });

    input?.addEventListener('change', () => {
      updateMinusButton(selector);
    });
  });


// 모바일 메뉴 drawer - 1depth 클릭 시 2depth 열리게
document.querySelectorAll('.menu-drawer__item-link-heading').forEach(summary => {
  summary.addEventListener('click', function (e) {
    const arrowButton = e.target.closest('.menu-drawer__item-link-arrow');

    // 이미 화살표 버튼 누른 거면 기존 로직 그대로 두기
    if (arrowButton) return;

    // summary 클릭 시 링크 이동 막기
    e.preventDefault();
    e.stopPropagation();

    // summary 안의 화살표 버튼 클릭 로직 실행
    this.querySelector('.menu-drawer__item-link-arrow')?.click();
  }, true);
});